import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import {
    getError, isUndNullEmpNew, sendMessageCloseCurrentWindow, settings, validatePhoneNumber, getResponse, getLanguageObj
} from '../../helpers/UtilsHelper'
import HtmlParser from 'react-html-parser';
import { UserService } from '../../services/users/UserService';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { AuthContextType } from '../../auth/AuthContext';
import { AccountClass } from '../../classes/account/accountClass';

const { icons, messages, labels, firebase } = settings;
const { fields: dbFields } = firebase?.firestore;

const authContextType = AuthContextType;

const currentMethod = 'AccountEdit - function';

export default function AccountEdit({
    modalObj = {
        $: {},
        account: {},
        setAccount: () => { },
        auth: authContextType,
        roles: [],
        setRoles: () => { },
        showModal: false,
        setShowModal: () => { },
        dtId: '',
        dtRowIndex: 0,
        setDtRowIndex: () => { },
        setDataDtRow: ({
            user = AccountClass?.getClass(),
            subMethod = '',
            languageObj = GlobalFormats?.getClass(),
        }) => { },
        processButtons: [],
        dateTimeFormat: { date: '', time: 0 },
    },
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const [roles_, setRoles_] = useState([]);
    const [errors, setErrors] = useState({ firstName: '', lastName: '', phoneNumber: '' });
    const [process, setProcess] = useState({ showLoading: false, save: false });
    const isMount = useRef(true);
    const { $, account, setAccount, auth = AuthContextType, dtId, dtRowIndex, setDtRowIndex, showModal, setShowModal, roles,
        setDataDtRow = ({
            user = AccountClass?.getClass(),
            subMethod = '',
            languageObj = GlobalFormats?.getClass(),
        }) => { },
    } = modalObj;
    //#endregion variables

    //#region methods
    const accountEdit = async (e) => {
        const subMethod = 'accountEdit';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();
            setProcess(prev => ({ ...prev, showLoading: true, save: true }));
            setErrors(prev => ({ ...prev, firstName: '', lastName: '', phoneNumber: '' }));

            // Data Validation
            response = await formDataValidate({ subMethod: subMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            // Execute Service
            const token = auth?.account?.tokenVzLaML?.token;
            response = await UserService.update({
                id: account?.id,
                data: account,
                token,
                subMethod: subMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const account_ = response?.result?.accountML || {};
            setAccount(account_);

            // Update DataTable
            // const dtRow = [
            //     account_?.email,
            //     setDateTimeFormatGlobal({
            //         date: account_?.created,
            //         type: dateTimeFormat?.date,
            //         format: dateTimeFormat?.time,
            //         subMethod: subMethod
            //     })?.result,
            //     setBadgeBooleanNew({ type: account_?.emailVerified, languageId: languageObj?.id }),
            //     setBadgeBooleanNew({ type: account_?.accountApproved, languageId: languageObj?.id }),
            //     setBadgeBooleanNew({ type: !isUndNullEmpNew({ data: account_?.role, subMethod: subMethod })?.result, languageId: languageObj?.id }),
            //     getProcessButtons({
            //         id: account_?.id,
            //         description: account_?.email,
            //         detailsShow: false,
            //         detailsLabel: labels?.detail?.[languageObj?.id],
            //         detailsEnabled: false,
            //         editShow: true,
            //         editLabel: labels?.edit?.[languageObj?.id],
            //         editEnabled: true,
            //         deleteShow: false,
            //         deleteLabel: labels?.delete?.[languageObj?.id],
            //         deleteEnabled: false,
            //         processButtons: processButtons,
            //         languageId: languageObj?.id,
            //         subMethod: subMethod
            //     })?.result,
            // ];

            const dtRow = setDataDtRow({
                user: account_,
                subMethod: subMethod,
                languageObj: languageObj
            })?.result;


            $(`#${dtId}`).DataTable().row(dtRowIndex).data(dtRow).draw(false);

            setAccount({});
            setDtRowIndex(0);

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}`;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, save: false }));

            if (response?.isSuccess && !response?.isWarning) setShowModal(false);

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: subMethod
            });
        }
    }

    const setFormValue = ({
        key = '',
        value = ''
    }) => {
        const subMethod = 'setFormValue';
        let response = getResponse({ type: 0 });
        try {
            if (key === dbFields?.roleId) {
                setAccount({
                    ...account,
                    [key]: value,
                    [dbFields?.role]: value === '' ? value : roles?.find(r => r?.id === value)?.description || ''
                });
            } else {
                setAccount({ ...account, [key]: value });
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            console.error(response);
        }
    }

    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            const rolesLocal = [...roles];
            if (!rolesLocal.some(r => r.id === '')) {
                rolesLocal.unshift({ id: '', description: labels?.selectRole?.[languageObj?.id], created: '', userId: '' });
            }
            setRoles_(rolesLocal);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: subMethod
            });
        }
    }

    const formDataValidate = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const errors_ = { firstName: '', lastName: '', phoneNumber: '' };

            if (isUndNullEmpNew({ data: account?.firstName, subMethod: currentMethod })?.result) {
                errors_.firstName = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmpNew({ data: account?.lastName, subMethod: currentMethod })?.result) {
                errors_.lastName = thisFieldRequired;
                response.isWarning = true;
            }

            if (!isUndNullEmpNew({ data: account?.phoneNumber, subMethod: currentMethod })?.result &&
                !validatePhoneNumber(account?.phoneNumber)) {
                errors_.phoneNumber = thisFieldRequired;
                response.isWarning = true;
            }

            setErrors(errors_);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal id='accountEditModal'
            backdrop='static'
            onHide={() => setShowModal(false)}
            show={showModal}
            centered
            contentClassName='border-0 shadow-lg login-card'>
            <Modal.Header closeButton className='bg-white border-bottom-0 pt-4 px-4 align-items-center'>
                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img alt='user' src={settings?.images?.user} style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
                </div>
                <div className='d-flex flex-column'>
                    <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.user?.[languageObj?.id]}</span>
                    <div className='d-flex align-items-center mt-1'>
                        <span className='badge badge-pill py-1 px-2 text-uppercase badge-warning text-dark'
                            style={settings?.html?.badges?.micro}>
                            {labels?.edit?.[languageObj?.id]}
                        </span>
                    </div>
                </div>
            </Modal.Header>

            <form onSubmit={accountEdit} method='post'>
                <Modal.Body className='px-4 pt-2'>
                    <div className='row'>
                        <div className='col-12'>
                            <label className='small font-weight-bold text-uppercase text-primary mb-3' style={{ letterSpacing: '1px' }}>
                                <i className={`${icons?.fasFa?.infoCircle} mr-1`} /> {labels?.personalInformation?.[languageObj?.id]}
                            </label>
                        </div>

                        <div className='col-12 col-md-6 mb-3'>
                            <div className='form-group'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.firstName?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                        onChange={(e) => setFormValue({ key: dbFields?.firstName, value: e?.target?.value })}
                                        placeholder={labels?.firstName?.[languageObj?.id]}
                                        title={labels?.firstName?.[languageObj?.id]}
                                        type='text'
                                        value={account?.firstName || ''}
                                        disabled={process?.showLoading}>
                                    </input>
                                </div>
                                {errors?.firstName && <div className={settings?.html?.errorText}>{HtmlParser(errors?.firstName)}</div>}
                            </div>
                        </div>

                        <div className='col-12 col-md-6 mb-3'>
                            <div className='form-group'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.lastName?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.user} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                        onChange={(e) => setFormValue({ key: dbFields?.lastName, value: e?.target?.value })}
                                        placeholder={labels?.lastName?.[languageObj?.id]}
                                        title={labels?.lastName?.[languageObj?.id]}
                                        type='text'
                                        value={account?.lastName || ''}
                                        disabled={process?.showLoading}>
                                    </input>
                                </div>
                                {errors?.lastName && <div className={settings?.html?.errorText}>{HtmlParser(errors?.lastName)}</div>}
                            </div>
                        </div>

                        <div className='col-12 mb-3'>
                            <div className='form-group'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.phoneNumber?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.mobileAlt} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon'
                                        title={labels?.phoneNumber?.[languageObj?.id]}
                                        type='text'
                                        onChange={(e) => setFormValue({ key: dbFields?.phoneNumber, value: e?.target?.value })}
                                        placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                        value={account?.phoneNumber || ''}
                                        disabled={process?.showLoading}>
                                    </input>
                                </div>
                                {errors?.phoneNumber && <div className={settings?.html?.errorText}>{HtmlParser(errors?.phoneNumber)}</div>}
                            </div>
                        </div>

                        <div className='col-12 mt-2'>
                            <label className='small font-weight-bold text-uppercase text-primary mb-3' style={{ letterSpacing: '1px' }}>
                                <i className={`${icons?.fasFa?.shieldAlt} mr-1`} /> {labels?.accountInformation?.[languageObj?.id]}
                            </label>
                        </div>

                        <div className='col-12 col-md-6 mb-3'>
                            <div className='form-group'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.email?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                    <input className='form-control border-0 shadow-sm form-input-icon bg-light'
                                        title={labels?.email?.[languageObj?.id]}
                                        type='text'
                                        readOnly
                                        value={account?.email || ''}>
                                    </input>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-6 mb-3'>
                            <div className='form-group'>
                                <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                    {labels?.role?.[languageObj?.id]}
                                </label>
                                <div className='position-relative'>
                                    <i className={`${icons?.fasFa?.listOl} position-absolute input-icon-left`} />
                                    <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                        disabled={process?.showLoading || (account?.emailVerified === false)}
                                        onChange={(e) => setFormValue({ key: dbFields?.roleId, value: e?.target?.value })}
                                        value={account?.roleId || ''}
                                        title={labels?.role?.[languageObj?.id]}>
                                        {roles_?.map((detail) => <option key={detail?.id} value={detail?.id}>{detail?.description}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100'>
                        <button className='btn btn-primary shadow-sm font-weight-bold mx-1 px-4 btn-primary'
                            data-title={labels?.save?.[languageObj?.id]}
                            disabled={process?.showLoading}
                            type='submit'>
                            {!process?.save ? (
                                <i className={`${icons?.fasFa?.save} mr-1`} />
                            ) : (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            )} {labels?.save?.[languageObj?.id]}
                        </button>
                        <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                            data-title={labels?.close?.[languageObj?.id]}
                            type='button'
                            disabled={process?.showLoading}
                            onClick={() => setShowModal(false)}>
                            <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-1`} /> {labels?.close?.[languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}